// @flow

class DataTypeAction {
    static CREATE_DATA_TYPE_ACTION = "CREATE_DATA_TYPE_ACTION";
    static UPDATE_DATA_TYPE_ACTION = "UPDATE_DATA_TYPE_ACTION";
}

export default DataTypeAction;